module.exports = __webpack_public_path__ + "static/me-748ad8405055d700ea4837d6b1b96f4c.jpg";